import { useState } from "react";

import { MenuSearchInput } from "common/components/MenuSearchInput";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import SelectButton from "common/components/ui/SelectButton";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { TIMEZONES } from "../constants";

import type { TimezoneOption } from "../types";

interface TimezoneSelectProps {
  className: string;
  selectedTimezone: TimezoneOption;
  onSelect: (newTimezone: TimezoneOption) => void;
  isDisabled: boolean;
  isScheduling: boolean;
}

export default function TimezoneSelect({
  className,
  selectedTimezone,
  onSelect,
  isDisabled,
  isScheduling,
}: TimezoneSelectProps) {
  const isDesktop = useTwBreakpoint("lg");

  const [inputValue, setInputValue] = useState("");

  const lowercasedInput = inputValue.toLowerCase();
  const filteredOptions = TIMEZONES.filter(
    ({ label, offset }) =>
      label.toLowerCase().includes(lowercasedInput) &&
      (isScheduling ? !!offset : true),
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={isDisabled}>
        <SelectButton
          className={className}
          id="timezone-select"
          hasSelection={!!selectedTimezone}
        >
          {selectedTimezone.label}
        </SelectButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="z-aboveDialog min-w-[--radix-dropdown-menu-trigger-width] max-md:max-w-[--radix-dropdown-menu-trigger-width]"
        align={isDesktop ? "end" : "start"}
      >
        <MenuSearchInput
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <DropdownMenuList>
          {filteredOptions.map((timezone) => (
            <DropdownMenuItem
              key={timezone.label}
              onSelect={() => {
                onSelect(timezone);
              }}
            >
              {timezone.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
